export const PARTNERS_CONSTANTS = {
  EBP: 'EBP',
  FEED_IT: 'feed-it',
  GEOFOLIA: 'Geofolia',
  IsaETA: 'IsaETA',
  ISAGRI: 'Isagri',
  Lavilog: 'Lavilog',
  LEA: 'LEA',
  MYCUMA: 'MyCUMA',
  SMAG: 'smag',
  MESPARCELLES: 'mesparcelles',
} as const;

export const PARTNER_METADATA_TO_DISPLAY = {
  [PARTNERS_CONSTANTS.SMAG]: {
    farms: ['farm_code'],
    fields: [],
  },
  [PARTNERS_CONSTANTS.MESPARCELLES]: {
    farms: ['siret'],
    fields: [],
  },
} as const;
